<template>
  <main>
    <div class="container-fluid message">
      <TopTemplate>
        <template #right-element>
          <router-link :to="{name: 'addRdv'}" class="btn button btn-primary" :disabled="loading">
            <i class="icon-Add"></i>
            {{ $t("button.addRdv") }}
          </router-link>
        </template>
        <template #left-element>
          <h3>{{ $t("title.listRdv") }}</h3>
        </template>
      </TopTemplate>
      <div class="search-date-wrapper">
        <div class="col-md-10 search">
          <input v-model="params.q" type="text" placeholder="Recherche" name="search" @input="searchRdv()" />
          <img src="../../assets/icons/search-icon.svg" class="icon-search" alt="search" />
        </div>
        <div class="col-md-2 search-date-message">
          <div class="select-wrapper">
            <div class="date-wrapper date-env">
              <span class>{{ $t("barFiltre.date") }}</span>
              <Datepicker v-model="datede" locale="fr" autoApply :enable-time-picker="false" :format="format_date_v1" @update:modelValue="searshRdvByDate" />
            </div>
          </div>
        </div>
      </div>

      <div>
        <nav>
          <div class="nav nav-tabs list-nav-pay" id="nav-tab" role="tablist">
            <button
              class="nav-link"
              id="nav-home-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-home"
              :class="{active: isReceved}"
              type="button"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true"
              key="1"
              @click="changeTypeRdv(true), (isReceved = true)"
            >
              {{ $t("rdv.parent") }}
            </button>

            <button
              class="nav-link"
              id="nav-home-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-home"
              :class="{active: !isReceved}"
              type="button"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true"
              key="1"
              @click="changeTypeRdv(false), (isReceved = false)"
            >
              {{ $t("msg.enseignant") }}
            </button>
          </div>
        </nav>
        <div class="col-12">
          <div v-if="this.isReceved" class="col-12">
            <button class="btn button btn-primary btn-stattus" @click="this.showFilter = !this.showFilter">
              {{ $t("button.trierStatut") }}
              <i class="arrow down"></i>
            </button>
            <div v-if="this.showFilter" class="liste-filter">
              <ul>
                <li @click="filterRdv(1, isReceved)">
                  {{ $t("button.tooltip.accepter") }}
                </li>
                <li @click="filterRdv(false, isReceved)">En attente</li>
                <li @click="filterRdv(2, isReceved)">{{ $t("button.tooltip.refusee") }}</li>
              </ul>
            </div>
          </div>
          <div v-if="!this.isReceved" class="col-12">
            <button class="btn button btn-primary btn-stattus" @click="this.showFilter = !this.showFilter">
              {{ $t("button.trierStatut") }}
              <i class="arrow down"></i>
            </button>
            <div v-if="this.showFilter" class="liste-filter">
              <ul>
                <li @click="filterRdv(4, isReceved)">Envoyé</li>
                <li @click="filterRdv(1, isReceved)">
                  {{ $t("button.tooltip.accepter") }}
                </li>
                <li @click="filterRdv(false, isReceved)">En attente</li>
                <li @click="filterRdv(2, isReceved)">{{ $t("button.tooltip.refusee") }}</li>
              </ul>
            </div>
          </div>

          <div class="tab-content" id="nav-tabContent" v-if="!loading && rdvs.length > 0">
            <div class="tab-pane fade show active">
              <div class="table message-list custom-table">
                <div class>
                  <div class="row">
                    <div v-if="loading" class="col-md-12">
                      <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
                        <div class="spinner-border text-info" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    </div>
                    <div class="table__wrapper">
                      <table>
                        <thead>
                          <tr>
                            <th>
                              <div v-if="isEnseignant">
                                {{ $t("msg.enseignant") }}
                                <div class="icon-wrapper" @click="sortB('teacher.full_name')">
                                  <i class="ri-arrow-up-s-line" :class="[specTri('teacher.full_name', true)]" />
                                  <i class="ri-arrow-down-s-line" :class="[specTri('teacher.full_name', false)]" />
                                </div>
                              </div>
                              <div v-else>
                                {{ $t("rdv.parent") }}
                                <div class="icon-wrapper" @click="sortB('studentParent.full_name')">
                                  <i class="ri-arrow-up-s-line" :class="[specTri('studentParent.full_name', true)]" />
                                  <i class="ri-arrow-down-s-line" :class="[specTri('studentParent.full_name', false)]" />
                                </div>
                              </div>
                            </th>
                            <th>
                              <div v-if="isEnseignant">
                                {{ $t("rdv.parent") }}
                                <div class="icon-wrapper" @click="sortB('studentParent.full_name')">
                                  <i class="ri-arrow-up-s-line" :class="[specTri('studentParent.full_name', true)]" />
                                  <i class="ri-arrow-down-s-line" :class="[specTri('studentParent.full_name', false)]" />
                                </div>
                              </div>
                              <div v-else>
                                {{ $t("msg.eleve") }}
                                <div class="icon-wrapper" @click="sortB('eleve.full_name')">
                                  <i class="ri-arrow-up-s-line" :class="[specTri('eleve.full_name', true)]" />
                                  <i class="ri-arrow-down-s-line" :class="[specTri('eleve.full_name', false)]" />
                                </div>
                              </div>
                            </th>
                            <th>
                              <div v-if="!isEnseignant">
                                {{ $t("msg.enseignant") }}
                                <div class="icon-wrapper" @click="sortB('student.full_name')">
                                  <i class="ri-arrow-up-s-line" :class="[specTri('student.full_name', true)]" />
                                  <i class="ri-arrow-down-s-line" :class="[specTri('student.full_name', false)]" />
                                </div>
                              </div>
                              <div v-else>
                                {{ $t("msg.eleve") }}
                                <div class="icon-wrapper" @click="sortB('teacher.full_name')">
                                  <i class="ri-arrow-up-s-line" :class="[specTri('teacher.full_name', true)]" />
                                  <i class="ri-arrow-down-s-line" :class="[specTri('teacher.full_name', false)]" />
                                </div>
                              </div>
                            </th>

                            <th class="td-sujet">{{ $t("common.sujet") }}</th>

                            <th>
                              {{ $t("common.date") }}
                              <div class="icon-wrapper" @click="sortB('appointment_date_at')">
                                <i class="ri-arrow-up-s-line" :class="[specTri('appointment_date_at', true)]" />
                                <i class="ri-arrow-down-s-line" :class="[specTri('appointment_date_at', false)]" />
                              </div>
                            </th>
                            <th>
                              {{ $t("common.hour") }}
                              <div class="icon-wrapper" @click="sortB('appointment_time')">
                                <i class="ri-arrow-up-s-line" :class="[specTri('appointment_time', true)]" />
                                <i class="ri-arrow-down-s-line" :class="[specTri('appointment_time', false)]" />
                              </div>
                            </th>

                            <th>{{ $t("common.status") }}</th>

                            <th class="text-center action-div">{{ $t("common.actions") }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="rdv in rdvs" :key="rdv.id">
                            <td>
                              {{ computedParent(rdv) }}
                            </td>
                            <td>
                              {{ computedEnseignant(rdv) }}
                            </td>
                            <td>
                              {{ computedStudent(rdv) }}
                            </td>
                            <td class="td-sujet">{{ rdv.description }}</td>
                            <td>{{ formatDateString(rdv.appointment_date_at) }}</td>
                            <td>{{ formatTime(rdv.appointment_time) }}</td>
                            <td>
                              <span :class="getStatusClasses(rdv)">
                                {{ getStatusText(rdv) }}
                              </span>
                            </td>
                            <td v-if="!isReceved && rdv.is_teacher === 0" class="col-md-2 text-center display-div"></td>
                            <td v-if="isReceved || (!isReceved && rdv.is_teacher === 1)" class="text-center action-div">
                              <div :class="{'custom-cursor interdit': [1, 2, 3].includes(rdv.status)}" class="margin-actions espace_height ml-4">
                                <span v-if="[1, 2, 3].includes(rdv.status)" class="tooltiptextinterdit">Cette action n'est plus possible</span>
                                <i class="icon-Add test" :class="{disaple: [1, 2, 3].includes(rdv.status)}" @click.prevent="refusRdv(rdv, 2)">
                                  <span class="tooltiptext">{{ $t("button.tooltip.refusee") }}</span>
                                </i>
                                <i class="icon-edit-02" @click="pushData(rdv), (this.showModal = true)" :class="{disaple: [1, 2, 3].includes(rdv.status)}">
                                  <span class="tooltiptext">{{ $t("button.tooltip.update") }}</span>
                                </i>

                                <i class="icon-Check" @click.prevent="refusRdv(rdv, 1)" :class="{disaple: [1, 2, 3].includes(rdv.status)}">
                                  <span class="tooltiptext">{{ $t("button.tooltip.accepter") }}</span>
                                </i>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div class="col-md-12">
                        <div class="table__wrapper__pagination-wrapper">
                          <div class="pagination">
                            <pagination v-if="last_page > 1" :data-set="pagination" @goToPage="getResults" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
          <div class="spinner-border text-info" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div class="container-fluid empty-message">
          <div class="col-md-12">
            <div v-if="!loading && rdvs.length === 0 && searchDate" class="card mt-4">
              <div class="col-12 empty-result text-center pt-3">
                <p>{{ $t("common.emptyRdvDate") }}</p>
              </div>
            </div>
            <div v-if="!loading && rdvs.length === 0 && !searchDate" class="card mt-4">
              <div class="col-12 empty-result text-center pt-3">
                <p>{{ $t("common.emptyRdv") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- modal -->
      <div v-if="showModal" class="modal-vue">
        <div class="overlay" @click="hideModal()"></div>
        <div class="modal-edition modal-rdv">
          <div class="titre-parent">
            <h3 class="title-modal">{{ $t("title.modifRdv") }}</h3>
            <button class="close" @click="hideModal()">
              <i class="icon-Add" />
            </button>
          </div>
          <div class="body-parent">
            <form @submit.prevent="updateRdv(rdv2)" novalidate autocomplete="off">
              <div class="spec-inputs">
                <div class="row">
                  <div class="col-md-6">
                    <div class="simple-input">
                      <div>
                        <input v-model="rdv2.parent" type="text" class="form-control" placeholder="Parent" disabled="disabled" />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="simple-input">
                      <div>
                        <input v-model="rdv2.enseignant" type="text" class="form-control" placeholder="Enseignant" disabled="disabled" />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="simple-input">
                      <div>
                        <Datepicker
                          v-model="rdv2.date"
                          class="custom-datepicker"
                          placeholder="Date"
                          :placeholder-class-name="customPlaceholderClass"
                          locale="fr"
                          autoApply
                          :enable-time-picker="false"
                          :format="format_date_v1"
                        />
                        <span v-if="v$.rdv2.date.$error" class="invalid-feedback">{{ v$.rdv2.date.$errors[0].$message }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="simple-input select-wrapper">
                      <input
                        v-model="rdv2.selectedHour"
                        type="text"
                        class="form-control"
                        placeholder="Heure"
                        @input="validateHourFormat"
                        :class="{'is-invalid': v$.rdv2.date.$error}"
                      />
                      <span class="indice">Seuls le format HH:MM (10:00)</span>
                      <span class="invalid-feedback" v-if="showInvalidFormatError && !v$.rdv2.selectedHour.$error">Format heure invalide</span>
                      <span v-if="v$.rdv2.selectedHour.$error" class="invalid-feedback">{{ v$.rdv2.selectedHour.$errors[0].$message }}</span>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="simple-input">
                      <div>
                        <textarea v-model="rdv2.description" type="text" class="form-control" placeholder="Sujet" disabled="disabled" />
                      </div>
                    </div>
                  </div>
                  <div class="col-12 buttons bloc-btn">
                    <div class="button-left">
                      <button type="button" class="btn btn-outline-primary button cancel" :disabled="loading" @click="hideModal()">
                        <i class="icon-Add" />
                        {{ $t("button.annuler") }}
                      </button>
                    </div>
                    <div class="button-right d-flex">
                      <button type="submit" class="btn button btn-primary" :disabled="loading || isConfirmed">
                        <i class="icon-Check" />
                        {{ $t("button.save") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import EventBus from "../../common/EventBus";

import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import pagination from "../../components/navigation/Pagination";
import RdvClass from "../../services/rdv.service";
import moment from "moment";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import vSelect from "vue-select";
import useValidate from "@vuelidate/core";

import {required, helpers} from "@vuelidate/validators";

import _ from "lodash";
export default {
  name: "listeRdv",
  components: {
    TopTemplate,
    pagination,
    Datepicker,
    "v-select": vSelect,
  },
  data() {
    return {
      v$: useValidate(),
      typeRdvR: null,
      showInvalidFormatError: false,
      searchDate: false,
      edit: false,
      showModal: false,
      isReceved: true,
      isEnseignant: false,
      tabIndex: 0,
      today: moment().format(),
      pagination: {},
      loading: false,
      last_page: null,
      is_current: true,
      rdv2: {
        description: null,
        parent: null,
        enseignant: null,
        selectedHour: null,
        heure: null,
      },
      showFilter: false,
      showRequiredError: false,
      showRequiredErrorDate: false,

      datede: "",
      hourOptions: [
        {label: "8:00", value: 8},
        {label: "9:00", value: 9},
        {label: "10:00", value: 10},
        {label: "11:00", value: 11},
        {label: "12:00", value: 12},
        {label: "13:00", value: 13},
        {label: "14:00", value: 14},
        {label: "15:00", value: 15},
        {label: "16:00", value: 16},
        {label: "17:00", value: 17},
        {label: "18:00", value: 18},
      ],
      selectedHour: "",
      params: {
        q: "",
        s: "cmp",
        limit: 7,
        page: 1,
        sort: "created_at",
        order: false,
      },
      rdv: {
        parent: "",
        enseignant: "",
      },
      rdvs: [],
    };
  },
  validations() {
    return {
      rdv2: {
        date: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        selectedHour: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
      },
    };
  },
  computed: {
    getStatusClasses() {
      return (rdv) => {
        if (rdv) {
          const status = rdv.status;
          switch (status) {
            case 0:
              return "en-attente";
            case 1:
              return "accepter";
            case 2:
              return "refuse";
            case 3:
              return "modifier";
            case 4:
              if (rdv.is_admin == 1) {
                return "envoye";
              }
              if (rdv.is_admin == 0) {
                return "en-attente";
              }
            default:
              return "";
          }
        }
      };
    },
    getStatusText() {
      return (rdv) => {
        if (rdv) {
          const status = rdv.status;
          switch (status) {
            case 0:
              if (!this.isReceved) {
                return rdv.is_admin === 1 ? this.$t("statusRdv.send") : this.$t("statusRdv.attend");
              }
              return this.$t("statusRdv.attend");
            case 1:
              return this.$t("statusRdv.accepted");
            case 2:
              return this.$t("statusRdv.refus");
            case 4:
              return rdv.is_admin === 1 ? this.$t("statusRdv.send") : this.$t("statusRdv.attend");
            default:
              return this.$t("statusRdv.update");
          }
        }
      };
    },
    computedEnseignant() {
      const firstName = this.isEnseignant ? "rdv.first_name_parent" : "rdv.first_name_student";
      const lastName = this.isEnseignant ? "rdv.last_name_student" : "rdv.last_name_student";

      return (rdv) => `${eval(firstName) ?? ""} ${eval(lastName) ?? ""}`;
    },
    computedParent() {
      const firstName = this.isEnseignant ? "rdv.first_name_teacher" : "rdv.first_name_parent";
      const lastName = this.isEnseignant ? "rdv.last_name_teacher" : "rdv.last_name_parent";

      return (rdv) => `${eval(firstName) ?? ""} ${eval(lastName) ?? ""}`;
    },
    computedStudent() {
      const firstName = this.isEnseignant ? "rdv.first_name_student" : "rdv.first_name_teacher";
      const lastName = this.isEnseignant ? "rdv.last_name_student" : "rdv.last_name_teacher";

      return (rdv) => `${eval(firstName) ?? ""} ${eval(lastName) ?? ""}`;
    },
  },
  created() {
    this.moment = moment;
  },
  mounted() {
    EventBus.on("call-list-function2", this.ListRdv);

    this.isEnseignant = JSON.parse(localStorage.getItem("isEnseignant"));
    if (this.isEnseignant) {
      this.isReceved = false;
    }

    this.changeTypeRdv(!this.isEnseignant);
    localStorage.removeItem("isEnseignant");
  },
  beforeUnmount() {
    //EventBus.off('call-list-function2', this.ListRdv);
  },
  methods: {
    filterRdv(data, isReceved) {
      console.log("date", isReceved);
      let typeRdv = isReceved ? 0 : 1;

      this.ListRdv(typeRdv, data);
    },
    changeTypeRdv(type) {
      this.params.q = null;
      this.params.page = 1;
      let typeRdv = type ? 0 : 1;
      this.isEnseignant = !type ? true : false;
      this.ListRdv(typeRdv);
    },

    formatDateString(dateString) {
      const formattedDate = moment.utc(dateString).format("DD-MM-YYYY");
      return formattedDate;
    },
    validateHourFormat() {
      const hourRegex = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/; // Regular expression to validate hour format
      this.showInvalidFormatError = !hourRegex.test(this.rdv2.selectedHour);
      this.showRequiredError = this.rdv2.selectedHour === "";
    },
    validateDateFormat() {
      this.showRequiredErrorDate = this.rdv2.date === "";
    },

    formatTime(timeString) {
      return moment(timeString, "HH:mm:ss").format("HH[h]mm");
    },

    pushData(rdv) {
      (this.rdv2.parent = rdv.first_name_parent),
        (this.rdv2.enseignant = rdv.first_name_teacher),
        (this.rdv2.date = rdv.appointment_date_at),
        (this.rdv2.selectedHour = rdv.appointment_time.slice(0, 5));
      (this.rdv2.description = rdv.description), (this.rdv2.id = rdv.id);
    },

    updateRdv(rdv2) {
      this.v$.$validate();
      if (!this.showInvalidFormatError && !this.v$.$error) {
        const data = {
          appointment_date_at: this.rdv2.date,
          appointment_time: this.rdv2.selectedHour,
        };

        RdvClass.update(this.rdv2.id, data)
          .then(() => {
            this.is_created = true;
            this.loading = false;
            this.showModal = false;
            const Swal2 = require("sweetalert2");

            Swal2.fire({
              title: "Vous-avez modifier le rendez-vous",
              icon: "warning",
              showCloseButton: true,
              showCancelButton: false,
              confirmButtonClass: "btn btn-confirm  btn-primary",
              confirmButtonText: this.$t("common.ok"),
              reverseButtons: true,
            }).then(() => {});
            this.getResults();
            EventBus.dispatch("call-list-function");
          })
          .catch((error) => {
            this.is_created = false;
            this.loading = false;
          });
      }
    },
    refusRdv(rdv, type) {
      const formattedDate = moment(rdv.appointment_date_at).format("DD-MM-YYYY");
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm  btn-primary",
          cancelButton: "btn  btn-cancel  btn-outline-primary",
        },
        buttonsStyling: false,
        showCloseButton: true,
      });
      swalWithBootstrapButtons
        .fire({
          title: `Voulez-vous vraiment ${type === 1 ? "Accepter" : "Refuser"} le rendez-vous de ${rdv.first_name_teacher} ${rdv.last_name_teacher} ?`,
          icon: "warning",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(
              `Vous avez ${
                type === 1
                  ? `un RDV avec M. ${rdv.first_name_teacher} ${rdv.last_name_teacher} le ${formattedDate}`
                  : `Refuser un RDV avec M. ${rdv.first_name_teacher} ${rdv.last_name_teacher} le ${formattedDate}`
              }`,
              "",
              "success"
            );
            RdvClass.refus(rdv.id, type).then(
              () => {
                EventBus.dispatch("call-list-function");
                this.getResults();
              },
              (error) => {
                this.loading = false;
              }
            );
          }
        });
    },

    ListRdv(typeRdv, status) {
      this.loading = true;
      RdvClass.getRdv({
        params: {
          date: this.datede,
          created_at: this.datede,
          q: this.params.q,
          limit: this.params.limit,
          sort: this.params.sort,
          order: this.params.order,
          is_admin: typeRdv,
          status_filter: status,
        },
      })
        .then((response) => {
          this.rdvs = response.data.data;
          this.total = response.data.meta.total;
          this.last_page = response.data.meta.last_page;
          this.pagination = this.makePagination(response.data.meta, response.data.links);
          this.loading = false;
          this.showFilter = false;
        })
        .catch((error) => {
          if (error.response && error.response.status === 403) {
            this.$router.push("/error-403");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    makePagination(meta, links) {
      return {
        current_page: meta.current_page,
        last_page: meta.last_page,
        next_page_url: links.next,
        prev_page_url: links.prev,
      };
    },

    getResults(page = null) {
      this.selected = [];
      this.params.page = !page ? this.params.page : page;
      this.loading = true;
      if (this.isReceved) {
        this.typeRdvR = 0;
      }
      if (!this.isReceved) {
        this.typeRdvR = 1;
      }

      RdvClass.getRdv({
        params: {
          q: this.params.q,
          limit: this.params.limit,
          page: this.params.page,
          sort: this.params.sort,
          order: this.params.order,
          is_admin: this.typeRdvR,
        },
      })
        .then((response) => {
          this.rdvs = response.data.data;
          this.pagination = this.makePagination(response.data.meta, response.data.links);
          this.total = response.data.meta.total;
          this.loading = false;
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    hideModal() {
      this.showModal = false;
      this.edit = false;
      localStorage.removeItem("edit");
    },
    specTri(param, order) {
      if (this.params.order === null && this.params.sort === "") {
        return "";
      } else {
        if (this.params.sort === param) {
          if (this.params.order === order) {
            return "ordredA";
          } else {
            return "ordredD";
          }
        } else {
          return "";
        }
      }
    },
    sortB: _.debounce(function (param) {
      this.params.order = this.params.order === false ? true : false;
      this.params.sort = param;
      if (this.isReceved) {
        this.ListRdv(1);
      }
      if (!this.isReceved) {
        this.ListRdv(0);
      }
    }, 200),
    sort(order, sort) {
      this.params.order = order;
      this.params.sort = sort;
      if (this.isReceved) {
        this.ListRdv(1);
      }
      if (!this.isReceved) {
        this.ListRdv(0);
      }
    },

    formatDateFR(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    searchRdv: _.debounce(function () {
      if (this.params.q.toString().length > 1 || !this.params.q.toString().length) {
        this.params.hasfilter = true;
      }
      if (this.isReceved) {
        this.ListRdv(0);
      }
      if (!this.isReceved) {
        this.ListRdv(1);
      }
    }, 200),

    searshRdvByDate: _.debounce(function () {
      this.searchDate = true;
      if (this.datede != null) {
        this.datede = this.dateTime(this.datede);
      }
      if (this.isReceved) {
        this.ListRdv(0);
      }
      if (!this.isReceved) {
        this.ListRdv(1);
      }
    }, 200),
    dateTime(value) {
      return moment(value).locale("fr").format("YYYY-MM-DD");
    },
    format_date_v1(value) {
      if (value) {
        return moment(String(value)).format("DD-MM-YYYY");
      }
    },
  },
};
</script>
<style scoped lang="scss">
.table__wrapper {
  padding-top: 0 !important;
}

.liste-filter {
  position: absolute;
  width: 144px;
  background: white;
  padding: 10px 15px;
  margin-top: 5px;
  border-radius: 5px;
  right: 30px;
  z-index: 10;
  box-shadow: 0 32px 64px rgba(0, 0, 0, 0.07);

  ul {
    padding: 0;
    margin: 0;

    li {
      list-style: none;
      font-size: 12px;
      padding-top: 5px;
      padding-bottom: 5px;
      cursor: pointer;

      &:hover {
        color: #377879;
      }
    }
  }
}

.btn-stattus {
  margin-top: 10px;
  margin-left: auto;
  color: #000000;
  box-shadow: none;
  background-color: white;
  border-color: white;
  font-size: 12px;
  font-weight: 500;

  i {
    border-width: 0 1px 1px 0 !important;
    margin-top: -5px;
    margin-left: 15px;
    margin-right: 5px;
  }
}

.search-date-wrapper {
  margin-left: 0px;
  margin-right: 0px;
  margin-bottom: 10px;
}

.empty-message {
  padding: 0 0px;
}

.custom-cursor {
  cursor: not-allowed;
}

#nav-tab {
  background: white;
  text-align: center;
  justify-content: center;
  padding: 5px;
}

.list-nav-pay .nav-link.active {
  color: #377879;
  font-weight: 700;
  font-size: 14px;
  border-bottom: none;
  background: transparent;
  border: none;
  border-bottom: 3px solid #377879 !important;
  margin-bottom: -5px;
}

.list-nav-pay .nav-link {
  color: #000000;
  font-size: 14px;
  font-weight: 700;
  line-height: 14px;
  letter-spacing: 0em;
  margin-left: 30px;
  margin-right: 30px;
}

.nav-link:hover,
.nav-link:focus {
  border: none !important;
}

.bloc-btn {
  display: flex;
  justify-content: flex-end;
}

.en-attente,
.accepter,
.refuse,
.envoye,
.modifier {
  font-size: 10px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  padding: 5px;
  border-radius: 5px;
}
.envoye {
  color: #1e4497;
  background-color: #1e44972b;
}
.en-attente {
  color: #f35b19;
  background-color: #f35b190f;
}

.refuse {
  color: #c43434;
  background-color: #e8a1a1;
}

.accepter {
  color: #377879;
  background-color: #f1fafa;
}

.swal2-styled.swal2-confirm {
  border: 0;
  border-radius: 0.25em;
  background: initial;
  background-color: #377879 !important;
  color: #fff;
  font-size: 1em;
}

.modifier {
  color: #3450c4;
  background-color: #a1c7e8;
}

.simple-input {
  margin-bottom: 15px;
}

input::placeholder,
textarea::placeholder,
.date-select .input.vs__search::placeholder {
  color: #000000;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
}

textarea {
  padding: 15px;
  height: 75px;
}

.title-modal {
  font-size: 16px;
  font-weight: 700;
  line-height: 23px;
  letter-spacing: 0px;
  text-align: left;
  color: #34b9bb;
}

.cancel {
  margin-right: 15px;

  i {
    transform: rotate(45deg);
  }
}

.action-div {
  min-width: 115px !important;

  .icon-Add:before {
    content: "\e913";
    rotate: 45deg;
    display: inline-block;
  }
}

.description-td {
  min-width: 20%;
}

.disaple {
  cursor: no-drop;
  opacity: 0.5;
  pointer-events: none;
}

.simple-input {
  input {
    padding: 0 15px !important;
    font-size: 12px !important;
  }

  textarea {
    font-size: 12px;
  }
}

.invalid-feedback {
  display: block;
}

.indice {
  margin: 0;
}

.interdit {
  position: relative;

  .tooltiptextinterdit {
    visibility: hidden;
    width: 165px;
    background-color: #e1f5f5;
    color: #34b9bb;
    text-align: center;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    font-size: 10px;
    top: -30px;
    transform: translateX(-50%);
    left: 40px;
  }

  &:hover {
    color: #34b9bb;

    .tooltiptextinterdit {
      visibility: visible;
    }
  }
}
</style>
